import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { goApi } from '../../../services';
import { LoadingSection } from '../../../common/LoadingSection';
import { BooleanField } from 'react-admin';
import UserInfo from '../../../common/UserInfo';
import { DateUtils } from '../../../date.utilitites';

export const BatchScheduleDetails = ({
    schedule,
    loading,
    error,
}: {
    schedule: any;
    loading: boolean;
    error: string | null;
}) => {
    if (loading)
        return (
            <div>
                <LoadingSection />
            </div>
        );
    if (error) return <div className="text-red-500">{error}</div>;
    if (!schedule) return null;
    return (
        <div className="h-[calc(100vh-180px)] overflow-y-auto" id="details-section">
            <div className="flex flex-row">
                <div className="flex flex-col space-y-2 text-sm">
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className={'font-medium mt-2'}>Title</label>
                        <p>{schedule?.title}</p>
                    </div>
                    {schedule?.streamKey && (
                        <div className="grid grid-cols-2 gap-2 border-b">
                            <label className={'font-medium mt-2'}>Stream Key</label>
                            <p>{schedule?.streamKey}</p>
                        </div>
                    )}
                    <div className={'grid grid-cols-2 gap-2 border-b'}>
                        <label className={'font-medium mt-2'}>Subject</label>
                        <p>{schedule?.subject?.name}</p>
                    </div>
                    <div className={'grid grid-cols-2 gap-2 border-b'}>
                        <label className={'font-medium mt-2'}>Primary Teacher</label>
                        <UserInfo user={schedule?.primaryTeacher} />
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className={'font-medium mt-2'}>Chat Enabled</label>
                        <BooleanField record={schedule} source="chatEnabled" />
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className={'font-medium mt-2'}>Is Demo</label>
                        <BooleanField record={schedule} source="isDemo" />
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className="font-medium mt-2">Created At</label>
                        <p>{DateUtils.formatDateTime(schedule?.createdAt)}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className="font-medium mt-2">Updated At</label>
                        <p>{DateUtils.formatDateTime(schedule?.updatedAt)}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className="font-medium mt-2">Start Time</label>
                        <p>{DateUtils.formatDateTime(schedule?.startTime)}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 border-b">
                        <label className="font-medium mt-2">End Time</label>
                        <p>{DateUtils.formatDateTime(schedule?.endTime)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
